import styled from "styled-components";
import { theme } from "@themes";

export const FilterContainer = styled.div`
  position: relative;
  border-top: solid 1px #cccc;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.background.light};
`;

export const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;

export const ButtonClean = styled.button`
  margin: 1rem !important;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 90%;
  height: 38px;
  margin: 0px auto;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonViewGraphs = styled.button`
    background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 90%;
  height: 38px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  margin-top: 23px;
  margin-left: 15px;
`;
export const ContentFilter = styled.div`
  padding-left: 10rem;
  display: grid;
  grid-template-columns: 13vw 13vw 13vw 13vw 13vw;
  column-gap: 1em;
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    padding-left: inherit;
  }
`;
